import React, { useEffect, useState } from 'react';
import CheckBox from '../../../../Shared/CheckBox/Checkbox';
import PopUp from '../../../../Shared/Popup/PopUp';
import Config from '../../../../../Config';

const UserAddressForUpgrade = (props) => {
  const [isOpenPopup, setIsOpenPopup] = useState(false);
  const [userAddress, setUserAddress] = useState({
    isSelectedAddress: { value: false, error: '' }
  });

  useEffect(() => {
    if (props.onSubmit) {
      const isValid = validate();
      props.onValid(isValid);
    }
  }, [props.onSubmit]);

  function openPackageDetailsInNewTab(e) {
    e.preventDefault();
    window.open(Config.lobbyUrl, '_blank').focus();
  }

  return (
    <div className='user-address-for-upgrade'>
      {props.userAddresses?.map((address, index) => {
        return (
          <div className={`address-wrapper ${props.selectedUserAddress?.ban == address.ban ? 'active' : ''}`} key={index} onClick={() => handleSelectAddress({ address: address, isSelectedSeparateInvoice: false })}>
            <div className='product-description'>שירות ב{address.productAddress?.fullAddress}</div>

            {
              address.products &&
              <div className='product-list'>
                {address.products?.map((product, i) => {
                  return (<div className='product-item' key={i}> {product.name} </div>)
                })}
              </div>
            }

            <div className='package-details-link'>
              <a href='#' target='_blank' onClick={(e) => openPackageDetailsInNewTab(e)}>פרטים על החבילה הקיימת שלי</a>
            </div>
          </div>
        );
      })}

      <div
        onClick={() => handleSelectAddress({ address: {}, isSelectedSeparateInvoice: true })}
        className={`address-wrapper new-address ${props?.isSelectedSeparateInvoice ? 'active' : ''}`}>
        להוסיף את השירות בכתובת אחרת
      </div>

      {userAddress.isSelectedAddress.error && <div className='error'>{userAddress.isSelectedAddress.error}</div>}

      <PopUp showPopUp={isOpenPopup} onClose={() => { setIsOpenPopup(false) }} footerBtn={{ text: 'הבנתי, תודה', onBtnClick: () => { setIsOpenPopup(false) } }}>
        <div className='popup-address-not-match'>
          <div className='popup-title'>
            שים לב, <br />
            כתובת זו אינה תואמת לכתובת שעודכנה בתחילת התהליך
          </div>
          <div className='popup-address'> {props.selectedAddress.streetName} {props.selectedAddress.home}, {props.selectedAddress.cityName}. </div>
          <div className='popup-text'> בחירה בה תהיה כרוכה בעדכון כתובת במערכות {window.Config.brand_Name_HE}</div>
        </div>
      </PopUp>

    </div>
  );


  function validate() {
    let isValid = true;

    if (!userAddress.isSelectedAddress.value) {
      isValid = false;
      userAddress.isSelectedAddress.error = 'אנא בחר אחת מן מהאפשרויות';
      setUserAddress({ ...userAddress });
    }
    return isValid;
  };

  function handleSelectAddress(data) {
    if (props.selectedAddress && Object.keys(props.selectedAddress).length > 0) {
      if (data.productAddress?.cityName != props.selectedAddress?.cityName
        || data.productAddress?.streetName != props.selectedAddress?.streetName
        || data.productAddress?.houseNumber != props.selectedAddress?.home
        || data.productAddress?.apprartment != props.selectedAddress?.apartment) {
        if (props.saleType != 'triple') {
          setIsOpenPopup(true);
        }
      }
    }

    userAddress['isSelectedAddress'] = { value: true, error: '' };
    setUserAddress({ ...userAddress });
    props.onSelectedUserAddress(data);
  }

};

export default UserAddressForUpgrade;
